const Constants = {
	KEY_ACCESS_TOKEN: 'token',
	KEY_REFRESH_TOKEN: 'refresh',
	KEY_SESSION_TOKEN: 'sid',
	MAX_LENGTH_PASSWORD: 40,
	MAX_LENGTH_EMAIL: 100,
	MAX_LENGTH_FIRSTNAME: 15,
	MAX_LENGTH_LASTNAME: 15,
	MIN_LENGTH_FIRSTNAME: 3,
};

export default Constants;
